import React from 'react';

import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import type { SuggestionQueryConfig } from './categoriseSearchGroups';

type SuggestionQueryConfigDialogProps = {
  open: boolean;
  onClose: () => void;
  config: SuggestionQueryConfig;
  isCustomised: boolean;
  onChange: (next: SuggestionQueryConfig) => void;
  onReset: () => void;
};

export default function SuggestionQueryConfigDialog({
  open,
  onClose,
  config,
  isCustomised,
  onChange,
  onReset,
}: SuggestionQueryConfigDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>NLS Suggestion matching rules</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Queries matching any entry are bucketed as NLS suggestions. Changes apply immediately to the results below.
          </Typography>
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={[...config.prefixes]}
            onChange={(_event, nextPrefixes) => {
              onChange({ ...config, prefixes: nextPrefixes });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Suggestion prefixes"
                helperText="Queries starting with any of these. Type and press Enter to add."
              />
            )}
          />
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={[...config.suffixes]}
            onChange={(_event, nextSuffixes) => {
              onChange({ ...config, suffixes: nextSuffixes });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Suggestion suffixes"
                helperText="Queries ending with any of these. Type and press Enter to add."
              />
            )}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onReset} disabled={!isCustomised}>
          Reset to defaults
        </Button>
        <Button variant="text" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
